import { createContext } from "react";
import type { XAxisActions } from "../XAxisProvider.types";

const XAxisActionsContext = createContext<XAxisActions | undefined>(undefined);
XAxisActionsContext.displayName = "XAxisActionsContext";

export default XAxisActionsContext;
